import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LayoutComponent } from './layout.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from '../material-module';
import { SharedModule } from '../shared/shared.module';
import { LayoutService } from './layout.service';
import { GuestDetailsComponent } from './guest-details/guest-details.component';
import { ConfirmationDetailsComponent } from './confirmation-details/confirmation-details.component';
import { ReservationService } from './reservation.service';
import { TablesLayoutComponent } from './tables-layout/tables-layout.component';
import { ReservationDetailsComponent, SeatingTypeFilter } from './reservation-details/reservation-details/reservation-details.component';
import { MessageComponent } from './message/message.component';
import { CoverTypePriceFilter } from './confirmation-details/confirmation-details.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { DataRetentionPolicyComponent } from '../layout/data-retention-policy/data-retention-policy.component';
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component';
@NgModule({
    declarations: [LayoutComponent, HeaderComponent, FooterComponent,
        ReservationDetailsComponent,
        GuestDetailsComponent,
        ConfirmationDetailsComponent,
        TablesLayoutComponent,
        MessageComponent,
        CoverTypePriceFilter, SeatingTypeFilter, TermsOfUseComponent, PrivacyPolicyComponent, DataRetentionPolicyComponent],
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        FormsModule,
        MaterialModule,
        SharedModule,
       
    ],
    exports: [LayoutComponent],
    providers: [LayoutService, ReservationService]
})
export class LayoutModule { }

